export default "__VITE_ASSET__DGFnpC6m__"